
import { defineComponent } from 'vue';

// Types
import type { Total } from '@white-label-types/parking-checkout';

import ReceiptBookingOrders from '../receipt-booking-orders/receipt-booking-orders.vue';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TicketPreloader, AdditionalInfoPreloader, PartnerizeTracking } from 'ui-shared-components'
// MIGRATION-TODO: This will be removed when migrating the next feature library

export default defineComponent({
  name: 'ReceiptBundleItems',

  components: {
    ReceiptBookingOrders,
    TicketPreloader,
    AdditionalInfoPreloader,
    PartnerizeTracking
  },

  props: {
    bundle: {
      type: Object,
      required: true,
    },

    contentLoading: {
      type: Boolean,
    },

    orderTotals: {
      type: Object as PropType<Total>,
      default: () => ({}),
    },
  },

  data() {
    return {
      modifications: {
        hideDirections: true,
        accessInfoFromEntranceInfo: true,
      },
    };
  },
});
